import Button from 'atoms/button/button';
import Heading from 'atoms/heading/heading';
import Label from 'atoms/label/label';
import ModalActions from 'atoms/modal/modalActions';
import ModalBody from 'atoms/modal/modalBody';
import ModalHeader from 'atoms/modal/modalHeader';
import ReactModal from 'atoms/modal/reactModal';
import TextInput from 'atoms/TextInput/textInput';
import { saveBookmark } from 'models/bookmarks/sagaActions';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import React, { useState } from 'react';
import { getDispatch } from 'reducers';
import { Bookmark } from './bookmarks';

// --- Props type ---
interface BookmarkDialogProps {
	onHide: () => void;
	selectedBookmark: Bookmark | null;
	tableId: string;
}

export const BookmarkDialog: React.FC<BookmarkDialogProps> = ({ tableId, selectedBookmark, onHide }) => {
	const [bookmarkName, setBookmarkName] = useState<string>(selectedBookmark?.BookmarkName ?? '');

	const dispatch = getDispatch();

	const handleSaveBookmark = () => {
		console.log({ selectedBookmark });
		if (!selectedBookmark) {
			dispatch(
				saveBookmark({
					tableId,
					bookmarkName,
				})
			);
			onHide();
			return;
		}
		const bookmarkId = selectedBookmark?.BookmarkID;
		dispatch(
			saveBookmark({
				tableId,
				bookmarkId,
				bookmarkName,
			})
		);
		onHide();
	};

	return (
		<ReactModal hideModal={onHide}>
			<ModalHeader>
				<Heading type="secondary">{selectedBookmark ? 'Edit Bookmark' : 'Create Bookmark'}</Heading>
			</ModalHeader>

			<ModalBody>
				<Stack isVertical gutter="small">
					<StackItem>
						<Label>Bookmark Name:</Label>
					</StackItem>
					<StackItem isStretch>
						<TextInput value={bookmarkName} onChange={(e) => setBookmarkName(e.target.value)} />
					</StackItem>
				</Stack>
			</ModalBody>

			<ModalActions>
				<Stack align="center" gutter="small">
					<StackItem>
						<Button isText name="Cancel" handleClick={onHide} />
					</StackItem>

					<StackItem isStretch align="right">
						<Button
							isPrimary
							disabled={!bookmarkName.trim().length}
							name={selectedBookmark ? 'Update' : 'Create'}
							handleClick={handleSaveBookmark}
						/>
					</StackItem>
				</Stack>
			</ModalActions>
		</ReactModal>
	);
};
